import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const MotivesRedux = createActions({
  MotivesExcelRequest: [''],
  MotivesExcelSuccess: [''],
  MotivesExcelError: ['error'],
},
{
  prefix: 'MOTIVES_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = MotivesRedux
export const MotivesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const MotivesExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const MotivesExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const MotivesExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.MotivesExcelRequest]: MotivesExcelRequest,
  [Types.MotivesExcelSuccess]: MotivesExcelSuccess,
  [Types.MotivesExcelError]: MotivesExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/MotivesRedux.js